module.exports = __webpack_public_path__ + "img/schoolbgD.9b03fbc4.png";